import {LamellaSet} from "./lamella-set.class";
import { v4 as uuidv4 } from 'uuid';
import {ColorConverter} from "../../../../core/util/color-converter";
import {LamellaListingItem} from "../../../types/lamella-listing-item.type";
import {Quaternion, Vector3} from "three";
import {environment} from "../../../../../environments/environment.dev";
import {deserializeWithInfinity} from "../../../util/infinity-serializer";


export class LamellaSetFactory {

    static createLamellaSet() : LamellaSet{
        return new LamellaSet(
            uuidv4(),
            "No name",
            "No code",
            26.5,
            26.5,
            26.5,
            26.5,
            Infinity,
            26.5,
            26.5,
            environment.FRAME_MAX_SPAN,
            "12798.obj",
            -1,
            'Powder Coated',
            ColorConverter.convert('#82898F'),
            new Vector3(0, 0, 0),
            new Quaternion(0, 0, 0, 0)
        );
    }



    static createLamellaSetFromLamellaListingItem(lamellaListingItem: LamellaListingItem): LamellaSet {
        return new LamellaSet(
            uuidv4(),
            lamellaListingItem.productName,
            lamellaListingItem.productCode,
            lamellaListingItem.minSpaceTop,
            lamellaListingItem.minSpaceBottom,
            lamellaListingItem.spaceTaken,
            lamellaListingItem.minSpace,
            Infinity,
            lamellaListingItem.height,
            lamellaListingItem.depth,
            lamellaListingItem.maxFrameSpan,
            lamellaListingItem.model3dUrl,
            lamellaListingItem.id,
            lamellaListingItem.defaultMaterial as 'Powder Coated' | 'Anodized',
            ColorConverter.convert(lamellaListingItem.defaultMaterialColor),
            new Vector3(...lamellaListingItem.offsetPosition),
            new Quaternion(...lamellaListingItem.offsetRotation)
        );
    }


    /**
     * Luo uusi `LamellaSet`-instanssi olemassaolevasta `LamellaSet`-instanssista.
     * Kopioi kaikki kentät paitsi UUID.
     * @param lamellaSet
     */
    static cloneLamellaSet(lamellaSet: LamellaSet): LamellaSet {
        return new LamellaSet(
            uuidv4(),
            lamellaSet.name,
            lamellaSet.productCode,
            lamellaSet.spaceBefore,
            lamellaSet.spaceAfter,
            lamellaSet.lamellaSpace,
            lamellaSet.lamellaSpaceBetween,
            deserializeWithInfinity(lamellaSet.lamellaRepeat),
            lamellaSet.height,
            lamellaSet.depth,
            lamellaSet.maxFrameSpan,
            lamellaSet.object3dUrl,
            lamellaSet.lamellaId,
            lamellaSet.material,
            lamellaSet.color,
            new Vector3(...lamellaSet.offsetPosition),
            new Quaternion(...lamellaSet.offsetRotation)
        );
    }

    /**
     * Luo uusi `LamellaSet`-instanssi olemassaolevasta `LamellaSet`-instanssista ja mahdollisista muutoksista.
     * Säilyttää UUIDn jos sitä ei anneta muutoksissa.
     * @param lamellaSet
     * @param changes
     */
    static createLamellaSetFromExisting(
        lamellaSet: LamellaSet,
        changes?: Partial<LamellaSet>
    ): LamellaSet {
        // Luodaan uusi instanssi, joka kopioi tarvittavat kentät
        const newLamellaSet = new LamellaSet(
            lamellaSet.id,
            lamellaSet.name,
            lamellaSet.productCode,
            lamellaSet.spaceBefore,
            lamellaSet.spaceAfter,
            lamellaSet.lamellaSpace,
            lamellaSet.lamellaSpaceBetween,
            lamellaSet.lamellaRepeat,
            lamellaSet.height,
            lamellaSet.depth,
            lamellaSet.maxFrameSpan,
            lamellaSet.object3dUrl,
            lamellaSet.lamellaId,
            lamellaSet.material,
            lamellaSet.color,
            lamellaSet.offsetPosition,
            lamellaSet.offsetRotation
        );

        // Sovelletaan optional-tyyppiset muutokset (jos `changes` määritelty)
        if (changes) {
            return Object.assign(newLamellaSet, changes);
        }

        return newLamellaSet;
    }

}